<template>
    <Breadcrumbs main="User" title="Edit Profile" />
    <div class="container-fluid">
        <div class="edit-profile">
            <div class="row">
                <userProfile />
                <editProfile />
                <userTable />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const userProfile = defineAsyncComponent(() => import("@/components/theme/user/edit/userProfile.vue"))
const editProfile = defineAsyncComponent(() => import("@/components/theme/user/edit/editProfile.vue"))
const userTable = defineAsyncComponent(() => import("@/components/theme/user/edit/userTable.vue"))
</script>